"use strict";
exports.__esModule = true;
var uuid_1 = require("uuid");
var PageImpressionContextMap = (function () {
    function PageImpressionContextMap() {
        this.pageImpressionContextMap = new Map();
    }
    PageImpressionContextMap.prototype.TrackPageView = function (pageName, pageUri) {
        var newContext = {
            impressionId: uuid_1.v4(),
            pageUri: pageUri,
            pageViewTick: Date.now()
        };
        this.pageImpressionContextMap.set(pageName, newContext);
        return newContext;
    };
    PageImpressionContextMap.prototype.GetContextForPage = function (pageName) {
        var _a;
        return (_a = this.pageImpressionContextMap.get(pageName), (_a !== null && _a !== void 0 ? _a : { impressionId: uuid_1.v4() }));
    };
    PageImpressionContextMap.prototype.ClearAll = function () {
        this.pageImpressionContextMap.clear();
    };
    return PageImpressionContextMap;
}());
exports.PageImpressionContextMap = PageImpressionContextMap;
//# sourceMappingURL=PageImpressionContextMap.js.map